import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { 
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import UniversalSidebar from "./UniversalSidebar";
import { PlayerSidebar } from "../player/PlayerSidebar";

export const MobileSidebar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  
  // Determine if we're on an admin, mentor, or player page
  const isAdmin = location.pathname.startsWith('/painel-admin');
  const isMentor = location.pathname.startsWith('/painel-mentor');
  const isPlayer = location.pathname.startsWith('/painel-jogador');
  const needsSidebar = isAdmin || isMentor || isPlayer;
  
  // Disable old mobile sidebar - replaced by new mobile menu system
  if (!needsSidebar) return null;
  
  return (
    <div className="md:hidden fixed top-2 left-2 z-50">
      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerTrigger asChild>
          <Button 
            size="icon" 
            variant="outline" 
            className="bg-[#1A2233]/80 backdrop-blur-sm border-[#2D3748] hover:bg-[#223342] text-[#00B6F0]"
          >
            <Menu className="h-5 w-5" />
          </Button>
        </DrawerTrigger>
        <DrawerContent className="h-full max-h-[100dvh] bg-transparent border-none">
          <div className="relative h-full overflow-auto">
            {(isAdmin || isMentor) && <UniversalSidebar />}
            {isPlayer && <PlayerSidebar />}
          </div>
        </DrawerContent>
      </Drawer>
    </div>
  );
};

export default MobileSidebar;
